import { Backdrop, Dialog, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import './user-api-key.scss'
import styles from "../../styles/_exports.module.scss";


const UserAPIKeyHistory = (props) => {
    const { keyHistoryList, apiKeyListHistoryHeader, open, handleCloseDialog } = props;

    return (
        <div>
            <Dialog
                open={open}
                handleCloseDialog={handleCloseDialog}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    style: { backdropFilter: "blur(3px)" },
                    onClick: handleCloseDialog,
                }}
                PaperProps={{ sx: { borderRadius: "10px", width: "100%", maxWidth: "100%" } }}
                sx={{ display: 'flex', alignItems: 'start', justifyContent: 'center', '& .MuiDialog-container': { width: '75%',}}}
            >
                <div className="user-key-history-paper-group">
                    <div className="key-history-header">
                        API Key Login History
                    </div>
                    <Paper className="user-key-paper" sx={{ height: "70vh" }}>
                        <div>
                            <TableContainer className="keyHistoryTableHeight">

                                <Table
                                    aria-labelledby="tableTitle"
                                    size='medium'
                                    className="user-key-table"
                                >
                                    <TableHead>

                                        <TableRow sx={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "white" }}>
                                            {
                                                apiKeyListHistoryHeader?.map((dataHead, index) => {

                                                    return (
                                                        <TableCell
                                                            key={`data-coll-header ${index}`}
                                                            align='left'
                                                            sx={{ color: styles.secondaryColor, fontWeight: styles.bold, fontSize: "1rem" }}
                                                            scope="row"
                                                        >
                                                            {dataHead?.headerTitle}
                                                        </TableCell>
                                                    )
                                                })
                                            }
                                        </TableRow>

                                    </TableHead>
                                    <TableBody>
                                        {
                                            (keyHistoryList)?.map((data, index) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        key={`filtered-coll ${index}`}
                                                        className='collection-row'
                                                    >

                                                        <TableCell
                                                            align="left"
                                                            sx={{ color: styles.mutedColor }}
                                                        >
                                                            <div className="flex-div-cell">
                                                                {data?.httpMethod}
                                                            </div>
                                                        </TableCell>

                                                        <TableCell align="left" sx={{ color: styles.mutedColor }}>
                                                            <div className="flex-div-cell">
                                                                {data?.baseUrl}
                                                            </div>
                                                        </TableCell>

                                                        <TableCell align="left" sx={{ color: styles.mutedColor }}>
                                                            <div className="flex-div-cell">
                                                                {data?.path}
                                                            </div>
                                                        </TableCell>

                                                        <TableCell align="left" sx={{ color: styles.mutedColor }}>
                                                            <div className="flex-div-cell">
                                                                {data?.body}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </Paper>
                </div>
            </Dialog>
        </div>
    )
}
export default UserAPIKeyHistory;